export default {
  actions: {
    FETCH_CONFIGURATION: 'FETCH_CONFIGURATION',
    CREATE_CONFIGURATION: 'CREATE_CONFIGURATION',
  },
  getters: {
    GET_CONFIGURATION: 'GET_CONFIGURATION',
    GET_ERROR: 'GET_ERROR',
  },
  mutations: {
    SET_CONFIGURATION: 'SET_CONFIGURATION',
    SET_ERROR: 'SET_ERROR',
    CLEAR_STATE: 'CLEAR_STATE',
  },
};
